import CryptoJS from "crypto-js";
import { _S2 } from "./aeskey";

function u8ToWordArray(u8: Uint8Array) {
  const words = [];
  let i = 0;
  const len = u8.length;

  while (i < len) {
    words.push(
      (u8[i++] << 24) |
      (u8[i++] << 16) |
      (u8[i++] << 8)  |
      (u8[i++] || 0)
    );
  }

  return CryptoJS.lib.WordArray.create(words, len);
}

export default class AesUtils {

  /** 运行期生成 key（无明文） */
  static _k() {
    return u8ToWordArray(_S2());
  }

  static encrypt(enData: string) {
    return CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(enData),
      AesUtils._k(),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();
  }

  static decrypt(data: string) {
    return CryptoJS.AES.decrypt(
      data,
      AesUtils._k(),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
  }
}
